import { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Form, Button, Container, Alert } from "react-bootstrap";
import axios from "axios";

const UpdatePayment = () => {
  const { orderId } = useParams();
  const { state } = useLocation();
  const grandTotal = state?.grandTotal || 0;

  const [discount, setDiscount] = useState(0);
  const [amount, setAmount] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("paid");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const finalTotal = grandTotal - parseFloat(discount || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (parseFloat(amount) > finalTotal) {
      setError(`Amount cannot exceed the final total of $${finalTotal.toFixed(2)} after discount.`);
      return;
    }
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    try {
      const res = await axios.post(`${API_BASE}/api/payments/add`, {
        order_id: orderId,
        customer_id: 1, // Replace with dynamic customer ID if needed
        amount,
        discount,
        payment_method: paymentMethod,
        payment_status: paymentStatus,
      });

      setSuccess(res.data.message);
    } catch (err) {
      setError("Failed to update payment");
    }
  };

  return (
    <Container className="mt-4">
      <h3>Update Payment for Order #{orderId}</h3>
      <Alert variant="info">
        Grand Total: ${grandTotal.toFixed(2)} <br />
        Discount: ${parseFloat(discount || 0).toFixed(2)} <br />
        <strong>Payable Total: ${finalTotal.toFixed(2)}</strong>
      </Alert>
      {success && <Alert variant="success">{success}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Discount</Form.Label>
          <Form.Control
            type="number"
            step="0.01"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            placeholder="0.00"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Amount Paid</Form.Label>
          <Form.Control
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Payment Method</Form.Label>
          <Form.Select
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            required
          >
            <option value="">--Select--</option>
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
            <option value="Online">Online</option>
          </Form.Select>
        </Form.Group>

        <Button type="submit">Submit Payment</Button>
      </Form>
    </Container>
  );
};

export default UpdatePayment;
